import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'dateformat'
})
export class Dateformat implements PipeTransform {
  transform(items: any) {
    let d = new Date(items)
    return moment(d).format('DD-MMM-YYYY')
  }
}


@Pipe({
  name: 'time'
})
export class TimeFormat implements PipeTransform {
  transform(items: any) {
    let d = (items)
    d = String(d)
    return d.substring(d.indexOf('T') + 1)
  }
}
@Pipe({
  name: 'fulltime'
})
export class FulltimeFormat implements PipeTransform {
  transform(items: any) {
    let d = String(items)
    return d.substring(d.indexOf(':') - 2, d.indexOf(':') + 6);
  }
}

@Pipe({
  name: 'timeAgo'
})

export class timeAgo implements PipeTransform {
  transform(date) {
    try {
      return moment(date).fromNow();
    }
    catch (err) {
      return date;
    }
  }
}
@Pipe({
  name: 'LocalDateTimePipe'
})
export class LocalDateTimePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe('en-US');
  }


  transform(val: any, format?: string, timezone?: string, locale?: string): string {
    if (val && val != '') {
      format = format || 'dd-MMM-yyyy hh:mm a';

      try {
        format = sessionStorage.getItem('defaultDateTimeFormatUI');
        if (!format || format == 'null') {
          format = format || 'dd-MMM-yyyy hh:mm a';
        }
      }
      catch (err) {
        console.log(err)
        format = format || 'dd-MMM-yyyy hh:mm a';
      }

      try {
        const date = moment.utc(val).format();
        val = moment.utc(date).local().format();
      }
      catch (e) {
      }
    }
    // Set the default format if not provided

    // Convert UTC to local time

    // Use the DatePipe instance to format the date
    return this.datePipe.transform(val, format, timezone, locale);
  }
}

@Pipe({
  name: 'LocalDatePipe'
})
export class LocalDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe('en-US');
  }


  transform(val: any, format?: string, timezone?: string, locale?: string): string {
    if (val && val != '') {
      format = format || 'dd-MMM-yyyy';
      try {
        format = sessionStorage.getItem('defaultDateFormatUI')
        if (!format || format == 'null') {
          format = format || 'dd-MMM-yyyy';
        }
      }
      catch (err) {
        console.log(err)
        format = format || 'dd-MMM-yyyy';
      }
      try {
        const date = moment.utc(val).format();
        val = moment.utc(date).local().format();
      }
      catch (e) {
      }
    }
    // Set the default format if not provided

    // Convert UTC to local time

    // Use the DatePipe instance to format the date
    return this.datePipe.transform(val, format, timezone, locale);
  }
}
